import React from "react";
import Neighborhood from "./Neighborhood/Neighborhood";
import styles from "./Neighborhoods.module.css";
import * as d3 from "d3";
import moment from "moment";

const parse_time = d3.timeParse("%m/%d/%Y");
const today = moment().format("MM/DD/YYYY");
const one_year_ago = moment().subtract(1, "years").format("MM/DD/YYYY");

const Neighborhoods = ({ data }) => {
  data = data.filter(
    (d) =>
      d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2021" ||
      (d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2020" &&
        parse_time(d.dateofincident) <= parse_time(one_year_ago))
  );
  const neighborhoods = d3.group(data, (d) => d.communityarea);

  const t = Array.from(neighborhoods, ([key, values]) => {
    let total_2020 = values.filter(
      (d) =>
        d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2020" &&
        parse_time(d.dateofincident) <= parse_time(one_year_ago)
    ).length;
    let total_2021 = values.filter(
      (d) =>
        d3.timeFormat("%Y")(parse_time(d.dateofincident)) === "2021" &&
        parse_time(today)
    ).length;
    let category = "same";
    if (total_2021 >= total_2020 + 2) {
      category = "above";
    }
    if (total_2021 <= total_2020 - 2) {
      category = "below";
    }
    return {
      key,
      values,
      category,
    };
  });

  return (
    <div className={styles.Neighborhoods}>
      <div>
        <h4>Where 2021 homicides are outpacing and 2020 homicides</h4>
        <p>
          Neighborhoods where homicides are on track to outpace the previous
          year. The charts are all to the same scale for comparison.
        </p>
        <div className={styles.SmallMultiples}>
          {t
            .sort((a, b) => (b.values.length > a.values.length ? 1 : -1))
            .filter((d) => d.category === "above")
            .map((d, i) => {
              return <Neighborhood key={d.key} data={d} index={i} />;
            })}
        </div>
      </div>
      <div>
        <h4>Where 2021 homicides are on par with 2020 homicides</h4>
        <div className={styles.SmallMultiples}>
          {t
            .sort((a, b) => b.values.length - a.values.length)
            .filter((d) => d.category === "same")
            .map((d, i) => {
              return <Neighborhood key={d.key} data={d} index={i} />;
            })}
        </div>
      </div>
      <div>
        <h4>
          Where 2021 homicides are on track to be below with 2020 homicides
        </h4>
        <div className={styles.SmallMultiples}>
          {t
            .sort((a, b) => b.values.length - a.values.length)
            .filter((d) => d.category === "below")
            .map((d, i) => {
              return <Neighborhood key={d.key} data={d} index={i} />;
            })}
        </div>
      </div>
    </div>
  );
};

export default Neighborhoods;
